<script>
  import VerticalNavBox from '@components/List/VerticalNavBox'

  export default {
    components: {
      VerticalNavBox,
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    computed: {
      // formattedList() {
      //   const $self = this
      //   const keys = Object.keys(this.list)
      //   const list= []
      //   keys.forEach((item)=> {
      //     const data = $self.list[item].map((dataList) =>{
      //       return {
      //         text: dataList.title,
      //         to: {
      //           name: 'brand-product-item',
      //           params: {
      //             productAlias: dataList.alias,
      //           },
      //         }
      //       }
      //     })
      //     list.push({
      //       text: item,
      //       to: {
      //         name: 'brand-product-list',
      //         params: {
      //           categoryAlias: item,
      //         },
      //       },
      //       data :{
      //         items:{
      //           ...data
      //         }

      //       }
      //     })
      //   })
      //   return list
      // }
    }
  }
</script>
<template>
  <section id="product" :class="$style.sectionProduct" class="section">
    <div class="container">
      <BaseSectionTitle
        title="產品系列"
        class="text-center"
      />
      <VerticalNavBox
        :list="list"
        :class="$style.VerticalNavBox"
      />
      <div class="text-center">
        <BaseButton
          class="isStylePrimary isRadius isCol4"
          :to="{ name: 'brand-product-list' }"
        >
          查看所有產品
        </BaseButton>
      </div>
    </div>
  </section>
</template>
<style lang="scss" module>
  .sectionProduct {
    .VerticalNavBox {
      box-shadow: 0 2px 4px rgba(33, 69, 88, 0.16);
      min-height: 400px;
      max-height: 538px;
    }

    :global {
      .sectionProduct {
        &__title {

        }
      }
    }
  }
</style>
